import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ChevronLeft, ChevronRight, ZoomIn } from 'lucide-react';

import im1 from './images1/realimag/1.jpeg';
import im2 from './images1/realimag/2.jpeg';
import im3 from './images1/realimag/3.jpeg';
import im4 from './images1/realimag/4.jpeg';
import im5 from './images1/realimag/5.jpeg';
import im6 from './images1/realimag/6.jpeg';
import im7 from './images1/realimag/7.jpeg';
import im8 from './images1/realimag/8.jpeg';
import im9 from './images1/realimag/9.jpeg';
import im10 from './images1/realimag/10.jpeg';
import im21 from './images1/realimag/21.jpeg';
import im22 from './images1/realimag/22.jpeg';
import im25 from './images1/realimag/25.jpeg';
import im26 from './images1/realimag/26.jpeg';
import im27 from './images1/realimag/27.jpeg';
import im28 from './images1/realimag/28.jpeg';
import im29 from './images1/realimag/29.jpeg';
import im30 from './images1/realimag/30.jpeg';
import im31 from './images1/realimag/31.jpeg';
import im32 from './images1/realimag/32.jpeg';
import im33 from './images1/realimag/33.jpeg';
import im35 from './images1/realimag/35.jpeg';

/* =========================================================
   NEW BIOGAS GALLERY IMAGES
   ========================================================= */

import biogas01 from './images1/gallery/biogas_01.jpeg';
import biogas02 from './images1/gallery/biogas_02.jpeg';
import biogas03 from './images1/gallery/biogas_03.jpeg';
import biogas04 from './images1/gallery/biogas_04.jpeg';
import biogas05 from './images1/gallery/biogas_05.jpeg';
import biogas06 from './images1/gallery/biogas_06.jpeg';


const galleryImages = [

  {
    src: im2,
    title: 'Real Image1',
    category: 'Real_image'
  },
  {
    src: im3,
    title: 'Real Image2',
    category: 'Real_image'
  },
  {
    src: im4,
    title: 'Real Image3',
    category: 'Real_image'
  },
  {
    src: im5,
    title: 'Real Image4',
    category: 'Real_image'
  },
  {
    src: im6,
    title: 'Real Image5',
    category: 'Real_image'
  },
  {
    src: im7,
    title: 'Real Image6',
    category: 'Real_image'
  },
  {
    src: im8,
    title: 'Real Image7',
    category: 'Real_image'
  },
  {
    src: im9,
    title: 'Real Image8',
    category: 'Real_image'
  },
  {
    src: im10,
    title: 'Real Image9',
    category: 'Real_image'
  },
  {
    src: im22,
    title: 'Real Image10',
    category: 'Real_image'
  },
  {
    src: im25,
    title: 'Real Image11',
    category: 'Real_image'
  },
  {
    src: im26,
    title: 'Real Image12',
    category: 'Real_image'
  },
  {
    src: im27,
    title: 'Real Image13',
    category: 'Real_image'
  },
  {
    src: im28,
    title: 'Real Image14',
    category: 'Real_image'
  },
  {
    src: im29,
    title: 'Real Image15',
    category: 'Real_image'
  },
  {
    src: im30,
    title: 'Real Image16',
    category: 'Real_image'
  },
  {
    src: im31,
    title: 'Real Image17',
    category: 'Real_image'
  },
  {
    src: im32,
    title: 'Real Image18',
    category: 'Real_image'
  },
  {
    src: im33,
    title: 'Real Image19',
    category: 'Real_image'
  },
  {
    src: im35,
    title: 'Real Image20',
    category: 'Real_image'
  },

  /* =========================================================
     NEW BIOGAS IMAGES
     Added to the existing Real_image gallery
     ========================================================= */

  {
    src: biogas01,
    title: 'Real Image21',
    category: 'Real_image'
  },
  {
    src: biogas02,
    title: 'Real Image22',
    category: 'Real_image'
  },
  {
    src: biogas03,
    title: 'Real Image23',
    category: 'Real_image'
  },
  {
    src: biogas04,
    title: 'Real Image24',
    category: 'Real_image'
  },
  {
    src: biogas05,
    title: 'Real Image25',
    category: 'Real_image'
  },
  {
    src: biogas06,
    title: 'Real Image26',
    category: 'Real_image'
  }

];

const categories = ['Real_image'];

export const GalleryPage = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [activeCategory, setActiveCategory] = useState('All');

  const filteredImages = activeCategory === 'All'
    ? galleryImages
    : galleryImages.filter(img => img.category === activeCategory);

  const currentIndex = selectedImage
    ? filteredImages.findIndex(img => img.src === selectedImage.src)
    : -1;

  const handlePrev = () => {
    if (currentIndex > 0) {
      setSelectedImage(filteredImages[currentIndex - 1]);
    }
  };

  const handleNext = () => {
    if (currentIndex < filteredImages.length - 1) {
      setSelectedImage(filteredImages[currentIndex + 1]);
    }
  };

  return (
    <div className="min-h-screen pt-20" data-testid="gallery-page">

      {/* Hero Section */}
      <section className="bg-emerald-950 py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          <motion.div
            className="text-center"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >

            <span className="text-amber-400 uppercase tracking-[0.3em] text-sm font-semibold">
              Our Work
            </span>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mt-4 mb-6">
              Image Gallery
            </h1>

            <p className="text-white/70 text-lg max-w-2xl mx-auto">
              Explore our projects, facilities, and team in action.
            </p>

          </motion.div>

        </div>
      </section>


      {/* Filter Tabs */}
      <section className="py-8 bg-white dark:bg-emerald-950 border-b border-slate-200 dark:border-emerald-800">

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          <div className="flex flex-wrap justify-center gap-4">

            {categories.map((category) => (

              <button
                key={category}
                onClick={() => setActiveCategory(category)}
                className={`px-6 py-2 uppercase tracking-wider text-sm font-semibold transition-all ${
                  activeCategory === category
                    ? 'bg-emerald-900 text-white'
                    : 'bg-slate-100 dark:bg-emerald-900 text-slate-600 dark:text-white/70 hover:bg-emerald-100 dark:hover:bg-emerald-800'
                }`}
                data-testid={`filter-${category.toLowerCase()}`}
              >
                {category}
              </button>

            ))}

          </div>

        </div>

      </section>


      {/* Gallery Grid */}
      <section className="py-16 bg-slate-50 dark:bg-emerald-900/30">

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          <motion.div
            className="gallery-grid"
            layout
          >

            <AnimatePresence>

              {filteredImages.map((image, index) => (

                <motion.div
                  key={image.src}
                  className="gallery-item rounded-none overflow-hidden relative group"
                  layout
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.9 }}
                  transition={{
                    duration: 0.3,
                    delay: index * 0.05
                  }}
                  onClick={() => setSelectedImage(image)}
                  data-testid={`gallery-item-${index}`}
                >

                  <img
                    src={image.src}
                    alt={image.title}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />

                  <div className="absolute inset-0 bg-emerald-950/60 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">

                    <div className="text-center">

                      <ZoomIn className="w-10 h-10 text-white mx-auto mb-2" />

                      <p className="text-white font-semibold">
                        {image.title}
                      </p>

                      <p className="text-amber-400 text-sm">
                        {image.category}
                      </p>

                    </div>

                  </div>

                </motion.div>

              ))}

            </AnimatePresence>

          </motion.div>

        </div>

      </section>


      {/* Lightbox */}
      <AnimatePresence>

        {selectedImage && (

          <motion.div
            className="lightbox-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelectedImage(null)}
            data-testid="lightbox"
          >

            <button
              className="absolute top-4 right-4 text-white hover:text-amber-400 z-10"
              onClick={() => setSelectedImage(null)}
              data-testid="lightbox-close"
            >
              <X size={32} />
            </button>


            {currentIndex > 0 && (

              <button
                className="absolute left-4 top-1/2 -translate-y-1/2 text-white hover:text-amber-400 z-10 bg-black/30 p-2 rounded-full"
                onClick={(e) => {
                  e.stopPropagation();
                  handlePrev();
                }}
                data-testid="lightbox-prev"
              >
                <ChevronLeft size={32} />
              </button>

            )}


            {currentIndex < filteredImages.length - 1 && (

              <button
                className="absolute right-4 top-1/2 -translate-y-1/2 text-white hover:text-amber-400 z-10 bg-black/30 p-2 rounded-full"
                onClick={(e) => {
                  e.stopPropagation();
                  handleNext();
                }}
                data-testid="lightbox-next"
              >
                <ChevronRight size={32} />
              </button>

            )}


            <motion.img
              key={selectedImage.src}
              src={selectedImage.src}
              alt={selectedImage.title}
              className="lightbox-image"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              onClick={(e) => e.stopPropagation()}
            />


            <div className="absolute bottom-8 left-1/2 -translate-x-1/2 text-center">

              <h3 className="text-white text-xl font-semibold">
                {selectedImage.title}
              </h3>

              <p className="text-amber-400">
                {selectedImage.category}
              </p>

              <p className="text-white/60 text-sm mt-2">
                {currentIndex + 1} / {filteredImages.length}
              </p>

            </div>

          </motion.div>

        )}

      </AnimatePresence>

    </div>
  );
};

export default GalleryPage;